<template>
  <div class="mobile">
    <div class="fullbox">
      <div class="goback">
        <div @click="goback">
          <i class="el-icon-arrow-left"></i>
          <span>返回</span>
        </div>
      </div>
      <div class="content">
        <div class="title-big">
          <div class="tit">高潜力员工诊断</div>
          <div class="con">
            本诊断的目的：高潜力员工是指那些具备能力、抱负和敬业度，能够在组织内部晋升并成功担任更高层级、更关键职位的员工。由于员工需要同时具备这三个属性，因此只有绩效位于顶尖水平的一小部分员工才被视为高潜力员工。本诊断将帮助您识别出同时具备这三个属性的员工。
          </div>
        </div>
        <div class="title-small">
          <img src="@/assets/evaluation/small1.png" alt="" />
          <div class="con">
            为了缩小员工范围，人力资源部门应首先识别出高绩效员工和担任关键角色的员工。为了从员工群体中识别出高潜力员工，人力资源部门和业务领导应使用下一个选项卡中的诊断问题。关于能力的问题最好由员工的直接上级回答，而关于抱负和敬业度的问题则最好由员工本人回答。
          </div>
        </div>
        <div class="bar-img">
          <img src="@/assets/evaluation/bar.png" alt="" />
        </div>
        <div class="btn">
          <el-button type="success" @click="toUrl('/evaluation/questions')"
            >转到问卷</el-button
          >
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  components: {},
  data() {
    return {};
  },
  mounted() {},
  methods: {
    //跳转
    toUrl(path) {
      this.$router.push(path);
    },
    //返回
    goback() {
      this.$router.go(-1);
    },
  },
};
</script>

<style lang="scss" scoped>
$zoom: 1020 / 375;
@media screen and (max-width: 600px) {
  .fullbox {
    width: 100%;
    // .btn {
    //   .el-button {
    //     width: 100%;
    //     height: 90px;
    //     background: #1fbe8a;
    //     border-radius: 10px;
    //     font-size: 28px;
    //     color: #fff;
    //     display: flex;
    //     align-items: center;
    //     justify-content: center;
    //     margin-top: 60px;
    //   }
    // }
  }
}
@media screen and (min-width: 600px) {
  .fullbox {
    width: 306px * $zoom;
    ::v-deep {
      .van-dropdown-item {
        width: 306px * $zoom !important;
        margin: auto;
      }
    }
    // .btn {
    //   .el-button {
    //     width: 90%;
    //     height: 90px;
    //     background: #1fbe8a;
    //     border-radius: 10px;
    //     font-size: 28px;
    //     color: #fff;
    //     display: flex;
    //     align-items: center;
    //     justify-content: center;
    //     position: absolute;
    //     bottom: 50px;
    //     left: 5%;
    //   }
    // }
  }
}
.mobile {
  width: 100%;
  display: flex;
  justify-content: center;
}
.fullbox {
  font-size: 14px * $zoom;
  position: relative;
  height: 100vh;
  padding-top: 30px;
  background: url("~@/assets/evaluation/bg2.png") no-repeat;
  background-size: 100% 100%;
  display: flex;
  flex-direction: column;
  overflow: auto;
  // 隐藏滚动条
  ::-webkit-scrollbar {
    display: none;
    width: 0 !important;
  }

  .goback {
    margin: 0 0 0 30px;
    display: flex;
    align-items: center;
    justify-content: space-between;

    div {
      display: flex;
      align-items: center;
    }

    i {
      font-weight: bold;
      font-size: 48px;
      margin-right: 40px;
    }

    span {
      font-size: 34px;
      flex-shrink: 0;
    }

    .goback_search {
      margin-left: 20px;
      display: flex;
      align-items: center;
      background: #fff;
      border-radius: 80px;
      height: 80px;
      // width: 58vw;
      padding: 0 30px 0 10px;

      align-items: center;
      justify-content: space-between;

      ::v-deep .el-input {
        flex: 1;
        height: 100%;

        &__inner {
          height: 100%;
          border: none;
          font-size: 28px;
          border-radius: 80px;
        }
      }

      i {
        font-size: 38px;
        margin-right: 10px !important;
      }
    }
  }
  .content {
    // background: #fff;
    border-radius: 50px 50px 0 0;
    flex: 1;
    padding: 50px 40px 40px;
    position: relative;
    .title-big {
      background: #1fbe8a;
      border-radius: 30px;
      color: #fff;
      padding: 40px;
      font-size: 26px;
      line-height: 40px;
      .tit {
        font-size: 36px;
        margin-bottom: 30px;
      }
    }
    .title-small {
      background: #fafafa;
      border-radius: 30px;
      color: #121826;
      padding: 40px;
      font-size: 26px;
      line-height: 40px;
      margin-top: 40px;
      img {
        width: 44px;
        height: 34px;
        margin-bottom: 20px;
      }
    }
    .bar-img {
      display: flex;
      justify-content: center;
      margin-top: 40px;
      img {
        width: 350px;
        height: 290px;
      }
    }
    .btn {
      .el-button {
        width: 100%;
        height: 90px;
        background: #1fbe8a;
        border-radius: 10px;
        font-size: 28px;
        color: #fff;
        display: flex;
        align-items: center;
        justify-content: center;
        margin-top: 60px;
      }
    }
  }
}
</style>
